var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47972 8.97963L7.02566 4.3418H7.97434L9.52029 8.97963L14.1581 10.5256V11.4743L9.52029 13.0202L7.97434 17.658H7.02566L5.47972 13.0202L0.841888 11.4743V10.5256L5.47972 8.97963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2297 2.72963L15.0257 0.341797H15.9743L16.7703 2.72963L19.1581 3.52557V4.47425L16.7703 5.2702L15.9743 7.65802H15.0257L14.2297 5.2702L11.8419 4.47425V3.52557L14.2297 2.72963Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorWhite);
export default __webpack_public_path__ + "static/media/Vector-white.04dc420137805a65710c10ad07af821c.svg";
export { ForwardRef as ReactComponent };